{
  "attendance.title": "الحضور",
  "attendance.sections.label": "أقسام الحضور",
  "attendance.sections.month": "الشهر",
  "attendance.sections.review": "المراجعة",
  "attendance.sections.imports": "استيراد البصمة",
  "attendance.sections.settings": "القواعد",

  "attendance.month.nav": "اختيار الشهر",
  "attendance.month.previous": "الشهر السابق",
  "attendance.month.next": "الشهر التالي",
  "attendance.month.this": "هذا الشهر",

  "attendance.status.present": "حاضر",
  "attendance.status.remote": "عمل من المنزل",
  "attendance.status.absent": "غياب",
  "attendance.status.missing_punch": "بصمة ناقصة",
  "attendance.status.paid_leave": "إجازة مدفوعة",
  "attendance.status.unpaid_leave": "إجازة بدون أجر",
  "attendance.status.holiday": "عطلة رسمية",
  "attendance.status.off": "راحة",
  "attendance.status.permission": "إذن",
  "attendance.status.external_meeting": "مأمورية",
  "attendance.status.not_entered": "لم يُسجَّل",
  "attendance.status.upcoming": "لم يأتِ بعد",
  "attendance.status.not_employed": "خارج مدة العمل",
  "attendance.status.not_required": "الحضور غير مطلوب",

  "attendance.plan.office": "مكتب",
  "attendance.plan.remote": "من المنزل",
  "attendance.plan.off": "راحة",

  "attendance.cell.worked": "{status} {duration}",
  "attendance.cell.short": "ناقص {duration}",
  "attendance.cell.exempted": "معفى من خصم النقص",
  "attendance.cell.manual": "حددته الموارد البشرية",
  "attendance.cell.adjusted": "عدّلته الموارد البشرية",
  "attendance.deduction.quarter": "خصم ربع يوم",
  "attendance.deduction.half": "خصم نصف يوم",
  "attendance.deduction.one": "خصم يوم",
  "attendance.deduction.days": "{count, plural, one {خصم يوم واحد} two {خصم يومين} few {خصم # أيام} many {خصم # يومًا} other {خصم # يوم}}",
  "attendance.review.missing_punch": "يحتاج مراجعة: بصمة ناقصة",
  "attendance.review.location_mismatch": "تسجيل حضور مكتب من خارج شبكة المكتب",
  "attendance.review.break_overrun": "استراحة أطول من المسموح",
  "attendance.review.long_stretch": "عمل ساعات متواصلة أكثر من المسموح دون تسجيل استراحة",
  "attendance.review.long_span": "اليوم امتد أطول من الحد من أوله لآخره",
  "attendance.review.long_presence": "بقي أكثر من أقصى ساعات مسموحة في اليوم",
  "attendance.review.missing_break_end": "استراحة لم تُقفل",

  "attendance.legend.label": "دليل الجدول",
  "attendance.legend.short": "ناقص عن ساعات اليوم المطلوبة",
  "attendance.legend.deduction": "خصم من المرتب بالأيام (¼ = ربع يوم)",
  "attendance.legend.manual": "خصم حددته الموارد البشرية",
  "attendance.legend.exempted": "معفى من خصم النقص",
  "attendance.legend.adjusted": "عدّلته الموارد البشرية",
  "attendance.legend.marks": "دليل الرموز",

  "attendance.grid.label": "الحضور، {month}",
  "attendance.grid.person": "الموظف",
  "attendance.grid.department": "القسم",
  "attendance.grid.allDepartments": "كل الأقسام",
  "attendance.grid.reviewOnly": "يحتاج مراجعة",
  "attendance.grid.selectDay": "تحديد أيام النقص يوم {date} ({count})",
  "attendance.grid.selectHint": "تتنقل الأسهم بين الأيام ويفتح Enter اليوم. لإعفاء عدة أيام نقص مرة واحدة اضغط المسافة أو Ctrl مع النقر، أو انقر رأس اليوم.",
  "attendance.grid.openProfile": "فتح حضوره",
  "attendance.grid.loadError": "تعذّر تحميل الشهر.",
  "attendance.grid.empty.title": "لا يوجد من نعرضه",
  "attendance.grid.empty.body": "لا يوجد في هذا القسم من يُتابَع حضوره هذا الشهر.",
  "attendance.grid.noReview.title": "لا شيء ينتظر المراجعة",
  "attendance.grid.noReview.body": "كل أيام هذا الشهر محسومة. أوقف الفلتر لعرض الجميع.",

  "attendance.totals.deducted": "{days, plural, one {خصم يوم واحد} two {خصم يومين} few {خصم # أيام} many {خصم # يومًا} other {خصم # يوم}}",
  "attendance.totals.absences": "{count, plural, one {غياب واحد} two {غيابان} few {# أيام غياب} many {# يوم غياب} other {# يوم غياب}}",
  "attendance.totals.reviews": "{count, plural, one {يوم للمراجعة} two {يومان للمراجعة} few {# أيام للمراجعة} many {# يومًا للمراجعة} other {# يوم للمراجعة}}",
  "attendance.totals.worked": "ساعات العمل",
  "attendance.totals.hoursValue": "{hours} س",
  "attendance.totals.deductedLabel": "الخصم",
  "attendance.totals.absencesLabel": "أيام الغياب",
  "attendance.totals.reviewsLabel": "للمراجعة",
  "attendance.calendar.label": "شهر {name}",

  "attendance.period.status.open": "الشهر مفتوح",
  "attendance.period.status.final": "الشهر مُعتمد",
  "attendance.period.status.locked": "الشهر مُقفل",
  "attendance.period.meaning.open": "يتعدّل ويُعاد حسابه",
  "attendance.period.meaning.final": "جاهز للمرتبات؛ أعد فتحه للتعديل",
  "attendance.period.meaning.locked": "أقفلته المرتبات نهائيًا",
  "attendance.period.blockers": "{count, plural, one {عنصر واحد يحتاج قرارًا قبل الاعتماد (يوم أو طلب)} two {عنصران يحتاجان قرارًا قبل الاعتماد (أيام أو طلبات)} few {# عناصر تحتاج قرارًا قبل الاعتماد (أيام أو طلبات)} many {# عنصرًا يحتاج قرارًا قبل الاعتماد (أيام أو طلبات)} other {# عنصر يحتاج قرارًا قبل الاعتماد (أيام أو طلبات)}}",
  "attendance.period.finalize": "اعتماد حضور الشهر",
  "attendance.period.reopen": "إعادة فتح الشهر",
  "attendance.period.finalizeTitle": "اعتماد شهر {month}؟",
  "attendance.period.finalizeBody": "أيام العمل التي لم يُسجَّل فيها شيء تُحتسب غيابًا، ولا تتغير الأيام حتى يُعاد فتح الشهر.",
  "attendance.period.reopenTitle": "إعادة فتح شهر {month}؟",
  "attendance.period.reopenBody": "تعود الأيام قابلة للتعديل وتُحسب من جديد، وتنتظر المرتبات حتى يُعتمد الشهر مرة أخرى.",
  "attendance.period.finalized": "تم اعتماد شهر {month}.",
  "attendance.period.reopened": "أُعيد فتح شهر {month}.",

  "attendance.selection.label": "الأيام المحددة",
  "attendance.selection.count": "{count, plural, one {يوم واحد محدد} two {يومان محددان} few {# أيام محددة} many {# يومًا محددًا} other {# يوم محدد}}",
  "attendance.selection.exempt": "إعفاء المحدد",
  "attendance.selection.clear": "إلغاء التحديد",
  "attendance.selection.exemptTitle": "إعفاء {count, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}} من خصم نقص الساعات؟",
  "attendance.selection.exemptBody": "تبقى ساعات العمل مسجّلة، ويصبح خصم النقص لهذه الأيام صفرًا. سبب واحد يكفي لها جميعًا.",
  "attendance.selection.exemptConfirm": "إعفاء {count, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  "attendance.selection.exempted": "{count, plural, one {تم إعفاء يوم واحد.} two {تم إعفاء يومين.} few {تم إعفاء # أيام.} many {تم إعفاء # يومًا.} other {تم إعفاء # يوم.}}",
  "attendance.selection.exemptedSkipped": "{count, plural, one {تم إعفاء يوم واحد} two {تم إعفاء يومين} few {تم إعفاء # أيام} many {تم إعفاء # يومًا} other {تم إعفاء # يوم}}، وتُرك {total} (شهر مغلق أو خارج مدة العمل).",

  "attendance.day.loadError": "تعذّر تحميل هذا اليوم.",
  "attendance.day.summary": "اليوم في لمحة",
  "attendance.day.planned": "المخطط: {status}",
  "attendance.day.workedOf": "{logged} من {estimate}",
  "attendance.day.noDeduction": "بدون خصم",
  "attendance.day.requests": "طلبات هذا اليوم",
  "attendance.day.closed.open": "هذا الشهر مفتوح",
  "attendance.day.closed.final": "هذا الشهر مُعتمد",
  "attendance.day.closed.locked": "هذا الشهر مُقفل",
  "attendance.day.closedBody.open": "يمكن تعديل الأيام.",
  "attendance.day.closedBody.final": "أعد فتح الشهر لتعديل أيامه.",
  "attendance.day.closedBody.locked": "أقفلت المرتبات هذا الشهر، فلم يعد تعديل أيامه ممكنًا من هنا.",

  "attendance.sessions.title": "فترات العمل",
  "attendance.sessions.none": "لا توجد فترات عمل مسجّلة لهذا اليوم.",
  "attendance.sessions.range": "{start} – {end}",
  "attendance.sessions.open": "{start} – الآن",
  "attendance.sessions.lonePunch": "بصمة واحدة الساعة {start}",
  "attendance.sessions.unpairedHint": "بصمة واحدة فقط: صحّح الفترة أو أكّد البصمة الناقصة.",
  "attendance.sessions.mode.office": "مكتب",
  "attendance.sessions.mode.remote": "عمل من المنزل",
  "attendance.sessions.source.app": "التطبيق",
  "attendance.sessions.source.device": "جهاز البصمة",
  "attendance.sessions.source.manual": "أضافتها الموارد البشرية",
  "attendance.sessions.add": "إضافة فترة",
  "attendance.sessions.save": "حفظ الفترة",
  "attendance.sessions.addTitle": "إضافة فترة عمل",
  "attendance.sessions.editTitle": "تصحيح فترة العمل",
  "attendance.sessions.dialogBody": "سجّل الوقت الذي عُمل فعلًا. تُحفظ الملاحظة في سجل اليوم.",
  "attendance.sessions.from": "من",
  "attendance.sessions.to": "إلى",
  "attendance.sessions.nextDay": "تنتهي في اليوم التالي",
  "attendance.sessions.modeLabel": "المكان",
  "attendance.sessions.note": "السبب",
  "attendance.sessions.edit": "تصحيح فترة {start}",
  "attendance.sessions.remove": "حذف فترة {start}",
  "attendance.sessions.removeTitle": "حذف هذه الفترة؟",
  "attendance.sessions.removeBody": "تُحذف فترة {start} ويُحسب اليوم من جديد.",
  "attendance.sessions.removeConfirm": "حذف الفترة",
  "attendance.sessions.added": "تمت إضافة الفترة.",
  "attendance.sessions.updated": "تم تصحيح الفترة.",
  "attendance.sessions.removed": "تم حذف الفترة.",
  "attendance.breaks.title": "الاستراحات",
  "attendance.breaks.none": "لا توجد استراحات مسجّلة.",
  "attendance.breaks.usedOf": "{used} من {total} المسموح بها · المتبقي {left}",
  "attendance.breaks.usedOver": "{used}، أكثر من {total} المسموح بها",
  "attendance.breaks.autoClosed": "انتهت عند الانصراف",
  "attendance.breaks.kindLabel": "النوع",
  "attendance.breaks.kind.regular": "استراحة",
  "attendance.breaks.kind.nursing": "استراحة رضاعة",
  "attendance.breaks.kindHint.regular": "تُحسب من وقت الاستراحة اليومي",
  "attendance.breaks.kindHint.nursing": "تُحسب وقت عمل (المادة 56)",
  "attendance.breaks.source.app": "التطبيق",
  "attendance.breaks.source.manual": "أضافتها الموارد البشرية",
  "attendance.breaks.add": "إضافة استراحة",
  "attendance.breaks.save": "حفظ الاستراحة",
  "attendance.breaks.addTitle": "إضافة استراحة",
  "attendance.breaks.editTitle": "تصحيح الاستراحة",
  "attendance.breaks.dialogBody": "سجّل الاستراحة زي ما حصلت فعلًا. السبب بيتحفظ في سجل اليوم.",
  "attendance.breaks.edit": "تصحيح استراحة {start}",
  "attendance.breaks.remove": "حذف استراحة {start}",
  "attendance.breaks.removeTitle": "حذف هذه الاستراحة؟",
  "attendance.breaks.removeBody": "تُحذف استراحة {start} ويُحسب اليوم من جديد.",
  "attendance.breaks.removeConfirm": "حذف الاستراحة",
  "attendance.breaks.added": "تمت إضافة الاستراحة.",
  "attendance.breaks.updated": "تم تصحيح الاستراحة.",
  "attendance.breaks.removed": "تم حذف الاستراحة.",
  "attendance.breaks.endBeforeStart": "لازم الاستراحة تنتهي بعد ما تبدأ.",
  "attendance.history.title": "سجل التعديلات",
  "attendance.history.field.status_override": "الحالة",
  "attendance.history.field.apply_shortfall_deduction": "خصم النقص",
  "attendance.history.field.manual_deduction": "الخصم اليدوي",
  "attendance.history.field.missing_punch_confirmed": "تأكيد البصمة الناقصة",
  "attendance.history.field.session": "فترة العمل",
  "attendance.history.field.break": "الاستراحة",
  "attendance.history.none": "—",
  "attendance.history.yes": "نعم",
  "attendance.history.no": "لا",
  "attendance.history.to": "إلى",
  "attendance.history.system": "النظام",

  "attendance.tier.title": "كيف حُسب الخصم",
  "attendance.tier.upTo": "نقص حتى {duration}",
  "attendance.tier.over": "نقص أكثر من {duration}",
  "attendance.tier.last": "الشريحة الأخيرة",
  "attendance.tier.withinGrace": "ضمن السماح ({duration})",
  "attendance.tier.days": "{count, plural, one {يوم واحد} two {يومان} few {# أيام} many {# يومًا} other {# يوم}}",
  "attendance.tier.hours": "{hours, plural, one {ساعة واحدة} two {ساعتان} few {# ساعات} many {# ساعة} other {# ساعة}}",
  "attendance.tier.exempted": "إعفاء: بدون خصم",
  "attendance.tier.replacedByManual": "خصم حددته الموارد البشرية يحل محل هذا الخصم.",

  "attendance.exemption.question": "تطبيق خصم نقص الساعات؟",
  "attendance.exemption.yes": "نعم",
  "attendance.exemption.no": "لا",
  "attendance.exemption.help": "عند اختيار «لا» تبقى ساعات العمل مسجّلة، ويصبح خصم النقص لهذا اليوم صفرًا.",
  "attendance.exemption.reason": "سبب الإعفاء",
  "attendance.exemption.reapplyReason": "سبب إعادة تطبيق الخصم",
  "attendance.exemption.save": "حفظ",
  "attendance.exemption.waived": "تم الإعفاء من خصم النقص لهذا اليوم.",
  "attendance.exemption.applied": "عاد تطبيق خصم النقص.",

  "attendance.missing.title": "بصمة ناقصة",
  "attendance.missing.body": "في هذا اليوم بصمة واحدة فقط. صحّح الفترة بالأعلى، أو أكّد البصمة الناقصة ليُطبَّق خصم اللائحة. لا يمكن اعتماد الشهر قبل حسمها.",
  "attendance.missing.confirmedTitle": "تم تأكيد البصمة الناقصة",
  "attendance.missing.confirmedBody": "يُطبَّق خصم اللائحة للبصمة الناقصة على هذا اليوم.",
  "attendance.missing.confirm": "تطبيق خصم البصمة الناقصة",
  "attendance.missing.confirmTitle": "تأكيد البصمة الناقصة؟",
  "attendance.missing.confirmBody": "يُطبَّق خصم اللائحة للبصمة الناقصة على هذا اليوم.",
  "attendance.missing.confirmBodyCost": "يُطبَّق خصم اللائحة على هذا اليوم: {amount}.",
  "attendance.missing.confirmed": "تم تأكيد البصمة الناقصة.",

  "attendance.adjust.title": "تعديلات الموارد البشرية",
  "attendance.override.label": "الحالة",
  "attendance.override.automatic": "كما سُجّلت (تلقائي)",
  "attendance.override.save": "حفظ الحالة",
  "attendance.override.saved": "تم حفظ الحالة.",
  "attendance.manual.label": "خصم يدوي",
  "attendance.manual.automatic": "تلقائي (حسب اللائحة)",
  "attendance.manual.kind.none": "بدون خصم",
  "attendance.manual.kind.one_hour": "ساعة",
  "attendance.manual.kind.two_hours": "ساعتان",
  "attendance.manual.kind.quarter_day": "ربع يوم",
  "attendance.manual.kind.half_day": "نصف يوم",
  "attendance.manual.kind.one_day": "يوم",
  "attendance.manual.kind.two_days": "يومان",
  "attendance.manual.kind.custom_days": "أيام (عدد آخر)",
  "attendance.manual.kind.custom_hours": "ساعات (عدد آخر)",
  "attendance.manual.days": "عدد الأيام",
  "attendance.manual.hours": "عدد الساعات",
  "attendance.manual.valueInvalid": "أدخل رقمًا أكبر من صفر وحتى ٣١.",
  "attendance.manual.save": "حفظ الخصم",
  "attendance.manual.saved": "تم حفظ الخصم.",

  "attendance.review.intro": "أيام تحتاج قرارًا. البصمة الناقصة تمنع اعتماد الشهر، والحضور كمكتب من خارج شبكة المكتب يحتاج مراجعة. الاستراحات والساعات الطويلة للاطلاع فقط: بلا خصم، ولا تمنع الاعتماد.",
  "attendance.review.caption": "أيام تنتظر المراجعة",
  "attendance.review.day": "اليوم",
  "attendance.review.status": "الحالة",
  "attendance.review.why": "السبب",
  "attendance.review.action": "القرار",
  "attendance.review.open": "فتح اليوم",
  "attendance.review.openDay": "فتح يوم {name}، {date}",
  "attendance.review.worked": "عمل {duration}",
  "attendance.review.loadError": "تعذّر تحميل قائمة المراجعة.",
  "attendance.review.empty.title": "لا شيء للمراجعة",
  "attendance.review.empty.body": "كل أيام هذا الشهر محسومة.",
  "attendance.review.empty.infoHidden": "لا شيء يحتاج قرارًا. أيام الاطلاع فقط مخفية، ويمكنك إظهارها من الخيار أعلاه.",
  "attendance.review.filter.label": "تصفية حسب السبب",
  "attendance.review.filter.all": "الكل",
  "attendance.review.filter.missing_punch": "بصمة ناقصة",
  "attendance.review.filter.location_mismatch": "من خارج المكتب",
  "attendance.review.filter.missing_break_end": "استراحة لم تُقفل",
  "attendance.review.filter.break_overrun": "استراحة طويلة",
  "attendance.review.filter.long_stretch": "بدون استراحة",
  "attendance.review.filter.long_span": "يوم ممتد",
  "attendance.review.filter.long_presence": "ساعات زائدة",
  "attendance.review.showInfo": "إظهار أيام الاطلاع فقط ({count})",

  "attendance.imports.title": "استيراد من جهاز البصمة",
  "attendance.imports.steps": "خطوات الاستيراد",
  "attendance.imports.step.upload": "الرفع",
  "attendance.imports.step.map": "ربط الأعمدة",
  "attendance.imports.step.preview": "المعاينة",
  "attendance.imports.step.done": "تم",
  "attendance.imports.drop": "اسحب ملف الجهاز إلى هنا أو اختره",
  "attendance.imports.formats": "CSV أو Excel (.xlsx)، حتى ١٠ ميجابايت",
  "attendance.imports.tooLarge": "الملف أكبر من ١٠ ميجابايت.",
  "attendance.imports.removeFile": "اختيار ملف آخر",
  "attendance.imports.upload": "رفع وقراءة",
  "attendance.imports.uploading": "جارٍ قراءة الملف…",
  "attendance.imports.back": "رجوع",
  "attendance.imports.toPreview": "معاينة",
  "attendance.imports.map.intro": "في {name} {count, plural, one {صف واحد} two {صفان} few {# صفوف} many {# صفًا} other {# صف}}. حدّد الأعمدة التي توضح من بصم ومتى.",
  "attendance.imports.map.employee": "عمود الموظف",
  "attendance.imports.map.idKind": "يحتوي هذا العمود على",
  "attendance.imports.map.idDevice": "رقم الموظف على الجهاز",
  "attendance.imports.map.idCode": "كود الموظف (404-001)",
  "attendance.imports.map.layout": "وقت كل بصمة موجود في",
  "attendance.imports.map.layoutTimestamp": "عمود واحد للتاريخ والوقت",
  "attendance.imports.map.layoutSplit": "عمود للتاريخ وعمود للوقت",
  "attendance.imports.map.timestamp": "عمود التاريخ والوقت",
  "attendance.imports.map.date": "عمود التاريخ",
  "attendance.imports.map.time": "عمود الوقت",
  "attendance.imports.map.dayFirst": "التواريخ تبدأ باليوم (13/10/2026)",
  "attendance.imports.map.choose": "اختر عمودًا",
  "attendance.imports.map.column": "العمود {number}",
  "attendance.imports.map.required": "اختر عمودًا.",
  "attendance.imports.preview.intro": "أول {count} من {total} صف كما ستُقرأ. الأعمدة المربوطة مميّزة.",
  "attendance.imports.preview.caption": "معاينة الملف",
  "attendance.imports.preview.row": "الصف",
  "attendance.imports.preview.flagged": "{count, plural, one {صف واحد يبدو ناقصًا} two {صفان يبدوان ناقصين} few {# صفوف تبدو ناقصة} many {# صفًا يبدو ناقصًا} other {# صف يبدو ناقصًا}}",
  "attendance.imports.preview.flaggedBody": "الصفوف بلا رقم أو وقت لن تُستورد. يمكنك المتابعة، وسيعرض الملخص كل صف تعذّرت قراءته.",
  "attendance.imports.issue.noEmployee": "بلا رقم",
  "attendance.imports.issue.noTime": "بلا وقت",
  "attendance.imports.commit": "استيراد {count, plural, one {صف واحد} two {صفين} few {# صفوف} many {# صفًا} other {# صف}}",
  "attendance.imports.committing": "جارٍ الاستيراد…",
  "attendance.imports.done.title": "تم استيراد {name}",
  "attendance.imports.done.body": "تحوّلت البصمات إلى فترات عمل وأُعيد حساب الأيام. البصمات المستوردة من قبل تُترك، فاستيراد الملف نفسه مرتين آمن.",
  "attendance.imports.done.imported": "بصمات مستوردة",
  "attendance.imports.done.skipped": "متروكة",
  "attendance.imports.done.skippedHint": "مستوردة من قبل أو غير مقروءة",
  "attendance.imports.done.problems": "صفوف بها مشاكل",
  "attendance.imports.done.problemList": "صفوف تعذّر استيرادها",
  "attendance.imports.done.row": "الصف {number}",
  "attendance.imports.done.another": "استيراد ملف آخر",
  "attendance.imports.done.openMonth": "فتح الشهر",
  "attendance.imports.history.title": "عمليات استيراد سابقة",
  "attendance.imports.history.file": "الملف",
  "attendance.imports.history.when": "وقت الرفع",
  "attendance.imports.history.status": "الحالة",
  "attendance.imports.history.committed": "تم الاستيراد",
  "attendance.imports.history.previewOnly": "لم يُستورد",
  "attendance.imports.history.loadError": "تعذّر تحميل عمليات الاستيراد السابقة.",
  "attendance.imports.history.empty.title": "لا توجد عمليات استيراد بعد",
  "attendance.imports.history.empty.body": "تظهر هنا ملفات جهاز البصمة بعد رفعها.",

  "attendance.policy.title": "لائحة الحضور",
  "attendance.policy.builtIn": "هذه هي القواعد الافتراضية لأنه لم تُحفظ قواعد بعد. راجعها واضغط «تعديل القواعد» لتثبيتها.",
  "attendance.policy.since": "منذ {date}",
  "attendance.policy.current": "الأحدث",
  "attendance.policy.edit": "تعديل القواعد",
  "attendance.policy.editTitle": "إصدار جديد من اللائحة",
  "attendance.policy.editIntro": "تُطبَّق القواعد الجديدة من التاريخ الذي تختاره، وتحتفظ الشهور السابقة بالقواعد التي حُسبت بها.",
  "attendance.policy.effectiveFrom": "تُطبَّق من",
  "attendance.policy.effectiveHint": "يجب أن تكون كل الشهور من هذا التاريخ مفتوحة.",
  "attendance.policy.dateRequired": "اختر تاريخ بدء التطبيق.",
  "attendance.policy.basics": "يوم العمل",
  "attendance.policy.dayBasis": "أيام شهر المرتب",
  "attendance.policy.dayBasisHint": "يُقسم المرتب الشهري على هذا العدد من الأيام.",
  "attendance.policy.dailyHours": "يوم العمل المعتاد",
  "attendance.policy.dailyHoursHint": "الساعات المطلوبة يوميًا، إلا لمن في ملفه ساعات أخرى. النقص يُحسب منها.",
  "attendance.policy.grace": "السماح قبل احتساب النقص",
  "attendance.policy.graceHint": "لو النقص في اليوم حتى هذا الحد فلا خصم؛ لو زاد يُحسب الخصم حسب الجدول أدناه.",
  "attendance.policy.absenceDays": "خصم الغياب",
  "attendance.policy.absenceDaysHint": "عن كل يوم غياب بلا إذن أو إجازة. 1 = أجر يوم كامل.",
  "attendance.policy.missingPunchDays": "خصم البصمة الناقصة",
  "attendance.policy.missingPunchHint": "لا يُطبَّق إلا بعد تأكيد الموارد البشرية للبصمة الناقصة.",
  "attendance.policy.overtime": "الساعات الإضافية",
  "attendance.policy.overtimeDay": "معدل الإضافي النهاري",
  "attendance.policy.overtimeDayHint": "لا يقل قانونًا عن ×1.35.",
  "attendance.policy.overtimeNight": "معدل الإضافي الليلي",
  "attendance.policy.overtimeNightHint": "لا يقل قانونًا عن ×1.70.",
  "attendance.policy.overtimeDayMin": "لا يمكن أن يقل المعدل النهاري عن ×1.35 (ولا يزيد على ×5).",
  "attendance.policy.overtimeNightMin": "لا يمكن أن يقل المعدل الليلي عن ×1.70 (ولا يزيد على ×5).",
  "attendance.policy.restDayPay": "العمل يوم الراحة يُصرف عنه",
  "attendance.policy.restDayPayHint": "إجمالي ما يُصرف عن العمل في يوم الراحة، بالأيام.",
  "attendance.policy.holidayPay": "العمل في العطلة الرسمية يُصرف عنه",
  "attendance.policy.holidayPayHint": "إجمالي ما يُصرف عن العمل في العطلة الرسمية؛ القانون: ضعف الأجر على الأقل.",
  "attendance.policy.addresses": "عناوين شبكة المكتب",
  "attendance.policy.addressesHint": "عنوان في كل سطر، مثل 41.33.10.4 أو 41.33.10.0/24. يُعلَّم حضور المكتب من عناوين أخرى للمراجعة. اتركه فارغًا لعدم التحقق.",
  "attendance.policy.addressesInvalid": "استخدم عناوين أو نطاقات مثل 41.33.10.4 أو 41.33.10.0/24 (حتى ٢٠).",
  "attendance.policy.noAddresses": "بدون تحقق",
  "attendance.policy.permissions": "الأذونات",
  "attendance.policy.permissionMode": "طريقة احتساب الإذن",
  "attendance.policy.permissionModes.credit_minutes": "احتساب دقائقه",
  "attendance.policy.permissionModes.exempt_day": "احتساب اليوم كله",
  "attendance.policy.permissionModeHints.credit_minutes": "يُعفى وقت الإذن بس.",
  "attendance.policy.permissionModeHints.exempt_day": "يُحسب اليوم كله يوم عمل كامل حتى لو الإذن ساعة واحدة.",
  "attendance.policy.permissionCount": "عدد الأذونات في الشهر",
  "attendance.policy.permissionsUnit": "في الشهر",
  "attendance.policy.permissionCountHint": "اتركه فارغًا إن لم يكن هناك حد.",
  "attendance.policy.permissionsValue": "{count} في الشهر",
  "attendance.policy.noLimit": "بدون حد",
  "attendance.policy.permissionMax": "أقصى مدة للإذن",
  "attendance.policy.permissionMaxHint": "من ١٥ دقيقة لـ ٨ ساعات.",
  "attendance.policy.permissionPaid": "هل وقت الإذن مدفوع؟",
  "attendance.policy.permissionUnpaidHint": "غير مدفوع: يُخصم وقت الإذن من المرتب.",
  "attendance.policy.paidYes": "مدفوع",
  "attendance.policy.paidNo": "غير مدفوع",
  "attendance.policy.permissionCountInvalid": "أدخل رقمًا صحيحًا من ٠ لـ ٣١، أو سيبه فاضي.",
  "attendance.policy.permissionMaxInvalid": "أدخل دقائق صحيحة من ١٥ لـ ٤٨٠.",
  "attendance.policy.limits": "الاستراحة وساعات العمل",
  "attendance.policy.limitsHelp": "الأيام اللي تعدّي الحدود دي بتظهر في قائمة المراجعة للاطلاع. مفيش خصم عليها، ومبتمنعش اعتماد الشهر.",
  "attendance.policy.breakMinutes": "الاستراحة اليومية",
  "attendance.policy.breakHint": "ساعة على الأقل (المادة 118).",
  "attendance.policy.breakInvalid": "أدخل من ٦٠ لـ ٢٤٠ دقيقة: ساعة على الأقل (المادة 118).",
  "attendance.policy.maxStretch": "أطول شغل متواصل",
  "attendance.policy.stretchHint": "لا يزيد عن ٥ ساعات متواصلة (المادة 118).",
  "attendance.policy.stretchInvalid": "أدخل من ٦٠ لـ ٣٠٠ دقيقة: مش أكتر من ٥ ساعات متواصلة (المادة 118).",
  "attendance.policy.maxSpan": "أطول يوم من أوله لآخره",
  "attendance.policy.spanHint": "١٠ ساعات بحد أقصى من أول اليوم لآخره (المادة 119).",
  "attendance.policy.spanInvalid": "أدخل من ٦٠ لـ ٦٠٠ دقيقة: ١٠ ساعات بالكتير من البداية للنهاية (المادة 119).",
  "attendance.policy.maxPresence": "أطول يوم مع الإضافي",
  "attendance.policy.presenceHint": "١٢ ساعة بحد أقصى شاملة الإضافي (المادة 121).",
  "attendance.policy.presenceInvalid": "أدخل من ٦٠ لـ ٧٢٠ دقيقة: ١٢ ساعة بالكتير مع الإضافي (المادة 121).",
  "attendance.policy.daysUnit": "يوم",
  "attendance.policy.hoursUnit": "ساعة",
  "attendance.policy.minutesUnit": "دقيقة",
  "attendance.policy.daysValue": "{days, plural, one {يوم واحد} two {يومان} few {# أيام} many {# يومًا} other {# يوم}}",
  "attendance.policy.outOfRange": "هذه القيمة خارج الحدود المسموحة في اللائحة.",
  "attendance.policy.fixFields": "بعض القيم تحتاج تصحيحًا قبل الحفظ.",
  "attendance.policy.reason": "سبب تغيير القواعد (اختياري)",
  "attendance.policy.save": "حفظ الإصدار الجديد",
  "attendance.policy.saved": "تم حفظ القواعد الجديدة.",
  "attendance.policy.history": "الإصدارات السابقة",
  "attendance.policy.loadError": "تعذّر تحميل قواعد الحضور.",
  "attendance.policy.tiers.title": "شرائح خصم النقص",
  "attendance.policy.tiers.help": "بعد السماح، تحدد كل شريحة خصم النقص حتى عدد معين من الدقائق، والشريحة الأخيرة لأي نقص أطول.",
  "attendance.policy.tiers.headUpTo": "لو النقص حتى",
  "attendance.policy.tiers.headFactor": "يُخصم",
  "attendance.policy.tiers.headUnit": "بالـ",
  "attendance.policy.tiers.longer": "أي نقص أطول",
  "attendance.policy.tiers.upTo": "الشريحة {number}: حتى كم دقيقة",
  "attendance.policy.tiers.factor": "الشريحة {number}: مقدار الخصم",
  "attendance.policy.tiers.unit": "الشريحة {number}: الوحدة",
  "attendance.policy.tiers.unitName.days": "أيام",
  "attendance.policy.tiers.unitName.hours": "ساعات",
  "attendance.policy.tiers.remove": "حذف الشريحة {number}",
  "attendance.policy.tiers.add": "إضافة شريحة",
  "attendance.policy.tiers.invalid": "يجب أن تتصاعد الشرائح، كل منها أكبر من صفر دقيقة، مع شريحة أخيرة مفتوحة، وخصم بين ٠ و٥.",
  "attendance.policy.tiers.grace": "بدون خصم",
  "attendance.policy.tiers.costDays": "{amount} يوم",
  "attendance.policy.tiers.costHours": "{amount} ساعة",

  "attendance.week.defaultTitle": "الأسبوع الافتراضي",
  "attendance.week.defaultBody": "يتبع الجميع هذا الأسبوع ما لم يُحدَّد لهم أسبوع خاص.",
  "attendance.week.builtIn": "لم يُحفظ أسبوع بعد، فيُستخدم الأسبوع المدمج المعروض هنا.",
  "attendance.week.personTitle": "جدول الأسبوع",
  "attendance.week.ownBody": "أسبوع خاص به",
  "attendance.week.followsDefault": "يتبع الأسبوع الافتراضي للوكالة",
  "attendance.week.edit": "تعديل الأسبوع",
  "attendance.week.fromHint": "تتبع الأيام من هذا التاريخ الأسبوع الجديد.",
  "attendance.week.save": "حفظ الأسبوع",
  "attendance.week.saved": "تم حفظ الأسبوع.",
  "attendance.week.department": "القسم",
  "attendance.week.departmentTitle": "أسبوع القسم",
  "attendance.week.departmentBody": "أسبوع خاص بالقسم ده",

  "attendance.profile.loadError": "تعذّر تحميل هذا الشهر.",
  "attendance.profile.untracked.title": "الحضور غير متابَع",
  "attendance.profile.untracked.body": "افتح ملف موارد بشرية بحضور مطلوب لعرض أيام هذا الشخص.",

  "attendance.mine.caption": "أيامي هذا الشهر",
  "attendance.mine.workedColumn": "ساعات العمل",
  "attendance.mine.deductionColumn": "الخصم",
  "attendance.mine.loadError": "تعذّر تحميل شهرك.",
  "attendance.mine.untracked.title": "حضورك غير متابَع",
  "attendance.mine.untracked.body": "عندما تفتح الموارد البشرية ملفك بحضور مطلوب، ستظهر أيامك هنا.",
  "attendance.mine.empty.title": "لا أيام لعرضها",
  "attendance.mine.empty.body": "ستظهر أيامك هنا عندما يبدأ احتساب حضورك في هذا الشهر.",

  "attendance.requests.mine": "طلباتي",
  "attendance.requests.mineBody": "الأذونات والمأموريات وأيام العمل من المنزل وتصحيح البصمة.",
  "attendance.requests.new": "طلب جديد",
  "attendance.requests.newTitle": "طلب حضور جديد",
  "attendance.requests.newBody": "يقرر مديرك أولًا، ثم الموارد البشرية.",
  "attendance.requests.send": "إرسال الطلب",
  "attendance.requests.sent": "تم إرسال الطلب.",
  "attendance.requests.loadError": "تعذّر تحميل طلباتك.",
  "attendance.requests.empty.title": "لا توجد طلبات بعد",
  "attendance.requests.empty.body": "اطلب إذنًا أو مأمورية أو يوم عمل من المنزل أو تصحيح بصمة.",
  "attendance.requests.kind.permission": "إذن",
  "attendance.requests.kind.external_meeting": "مأمورية",
  "attendance.requests.kind.work_from_home": "عمل من المنزل",
  "attendance.requests.kind.punch_correction": "تصحيح بصمة",
  "attendance.requests.kindHint.permission": "تأخير في الحضور أو خروج أثناء اليوم أو انصراف مبكر",
  "attendance.requests.kindHint.external_meeting": "عمل خارج المكتب طوال اليوم",
  "attendance.requests.kindHint.work_from_home": "العمل من المنزل في يوم مكتب",
  "attendance.requests.kindHint.punch_correction": "تصحيح بصمة منسية أو خاطئة",
  "attendance.requests.edge.late_arrival": "تأخير في الحضور",
  "attendance.requests.edge.early_leave": "انصراف مبكر",
  "attendance.requests.edge.during_hours": "خروج أثناء اليوم",
  "attendance.requests.overQuota": "فوق حد الشهر",
  "attendance.requests.exceptionReason": "سبب الاستثناء:",
  "attendance.requests.quota.used": "استخدمت {used} من {total} الشهر ده",
  "attendance.requests.quota.usedNoLimit": "استخدمت {used} الشهر ده، ومفيش حد",
  "attendance.requests.quota.each": "لحد {duration} للإذن",
  "attendance.requests.quota.unpaid": "بدون أجر",
  "attendance.requests.quota.reachedTitle": "خلّصت أذونات الشهر ده",
  "attendance.requests.quota.reachedBody": "تقدر تبعته برضه. هيروح للموارد البشرية كاستثناء، وهي بس اللي تقدر توافق عليه.",
  "attendance.requests.status.pending": "قيد الانتظار",
  "attendance.requests.status.approved": "مقبول",
  "attendance.requests.status.rejected": "مرفوض",
  "attendance.requests.status.cancelled": "مسحوب",
  "attendance.requests.form.kind": "ماذا تحتاج؟",
  "attendance.requests.form.date": "اليوم",
  "attendance.requests.form.edge": "متى",
  "attendance.requests.form.start": "الحضور الفعلي",
  "attendance.requests.form.end": "الانصراف الفعلي",
  "attendance.requests.form.reason": "السبب",
  "attendance.requests.form.dateRequired": "اختر اليوم.",
  "attendance.requests.form.timeInvalid": "أدخل وقتًا مثل 09:05.",
  "attendance.requests.form.endBeforeStart": "يجب أن يكون الانصراف بعد الحضور.",
  "attendance.requests.form.from": "من",
  "attendance.requests.form.to": "إلى",
  "attendance.requests.form.length": "المدة {duration}",
  "attendance.requests.form.permissionTooLong": "أقصى مدة للإذن {duration}.",
  "attendance.requests.form.permissionEndBeforeStart": "لازم النهاية تكون بعد البداية.",
  "attendance.requests.showFlow": "خطوات الموافقة",
  "attendance.requests.cancel": "سحب الطلب",
  "attendance.requests.cancelTitle": "سحب هذا الطلب؟",
  "attendance.requests.cancelBody": "لن يحتاج أحد للبت فيه بعد الآن.",
  "attendance.requests.cancelConfirm": "سحب الطلب",
  "attendance.requests.keep": "إبقاء الطلب",
  "attendance.requests.cancelled": "تم سحب الطلب.",

  "attendance.clock.label": "ساعة الحضور",
  "attendance.clock.title": "الحضور",
  "attendance.clock.on": "حاضر",
  "attendance.clock.sinceShort": "{mode} · من {start}",
  "attendance.clock.in": "تسجيل الحضور",
  "attendance.clock.out": "تسجيل الانصراف",
  "attendance.clock.inShort": "حضور",
  "attendance.clock.outShort": "انصراف",
  "attendance.clock.plan.office": "يوم مكتب",
  "attendance.clock.plan.remote": "يوم من المنزل",
  "attendance.clock.plan.off": "يوم راحة",
  "attendance.clock.since": "حاضر منذ {start}",
  "attendance.clock.inToast": "تم تسجيل الحضور الساعة {start}.",
  "attendance.clock.outToast": "تم تسجيل الانصراف الساعة {start}.",
  "attendance.clock.mismatch": "سُجّل الحضور كمكتب من خارج شبكة المكتب، وستراجعه الموارد البشرية.",
  "attendance.clock.mismatchToast": "تم تسجيل الحضور. أنت خارج شبكة المكتب، لذا ستراجع الموارد البشرية حضور المكتب هذا.",
  "attendance.break.start": "بدء الاستراحة",
  "attendance.break.end": "إنهاء الاستراحة",
  "attendance.break.startShort": "استراحة",
  "attendance.break.endShort": "رجعت",
  "attendance.break.onBreak": "في استراحة",
  "attendance.break.since": "في استراحة من {start}",
  "attendance.break.today": "استراحة النهارده",
  "attendance.break.used": "{used} من {total} دقيقة",
  "attendance.break.left": "فاضلك {left} دقيقة استراحة",
  "attendance.break.over": "{used} دقيقة، أكتر من {total}",
  "attendance.break.overHint": "عدّيت وقت الاستراحة النهارده. الموارد البشرية هتشوفه، ومفيش خصم.",
  "attendance.break.startToast": "بدأت الاستراحة الساعة {start}.",
  "attendance.break.endToast": "أهلًا بيك. الاستراحة دي خدت {took} دقيقة، وإجمالي النهارده {used} من {total} دقيقة، وفاضلك {left} دقيقة.",
  "attendance.break.overToast": "أهلًا بيك. الاستراحة دي خدت {took} دقيقة، وإجمالي النهارده {used} دقيقة، أكتر من {total}: الموارد البشرية هتشوفها، ومفيش خصم.",
  "attendance.break.resumeToast": "بدأت الاستراحة الساعة {start}. استخدمت {used} دقيقة قبل كده، وفاضلك {left} دقيقة.",
  "attendance.break.totalToday": "إجمالي استراحاتك النهارده",
  "attendance.break.thisOne": "الاستراحة دي بدأت {start}",
  "attendance.clock.workedToday": "شغلك النهارده، من غير الاستراحات",
  "attendance.presence.title": "دلوقتي",
  "attendance.presence.refresh": "بيتحدّث كل دقيقة",
  "attendance.presence.filter": "عرض الناس حسب الحالة",
  "attendance.presence.list": "مين موجود دلوقتي",
  "attendance.presence.state.working": "شغّال",
  "attendance.presence.state.on_break": "في استراحة",
  "attendance.presence.state.on_leave": "في إجازة",
  "attendance.presence.state.off_duty": "خارج الدوام",
  "attendance.presence.since": "من {start}",
  "attendance.presence.onBreakSince": "في استراحة من {start}",
  "attendance.presence.breaks": "الاستراحة {used} من {total} · فاضل {left}",
  "attendance.presence.breaksOver": "الاستراحة {used}، أكتر من {total} المسموح",
  "attendance.presence.loadError": "تعذّر تحميل مين موجود دلوقتي.",
  "attendance.presence.noneInState": "مفيش حد في الحالة دي دلوقتي.",
  "attendance.presence.nobodyIn": "الكل خارج الدوام الآن.",

  "attendance.errors.periodLocked": "هذا الشهر مُقفل، ولم يعد تعديل أيامه ممكنًا.",
  "attendance.errors.periodFinal": "هذا الشهر مُعتمد. أعد فتحه لتعديل أيامه.",
  "attendance.errors.periodBlockers": "ما زالت هناك أيام تنتظر المراجعة أو طلبات تنتظر قرارًا، فلا يمكن اعتماد الشهر بعد.",
  "attendance.errors.alreadyClockedIn": "سجّلت حضورك بالفعل.",
  "attendance.errors.notClockedIn": "لم تسجّل حضورك.",
  "attendance.errors.sessionNotFound": "هذه الفترة لم تعد موجودة.",
  "attendance.errors.sessionOverlap": "هذه الفترة تتداخل مع فترة أخرى في اليوم نفسه.",
  "attendance.errors.sessionInvalid": "راجع الأوقات: يجب أن تكون النهاية بعد البداية، خلال يوم واحد، ولا تكون في المستقبل.",
  "attendance.errors.noRecord": "لا يوجد ملف موارد بشرية بحضور مطلوب لهذا الشخص.",
  "attendance.errors.reason": "اكتب سبب التغيير.",
  "attendance.errors.policyInvalid": "هذه القواعد غير متسقة. راجع الشرائح والحدود.",
  "attendance.errors.importNotFound": "عملية الاستيراد هذه لم تعد موجودة. ارفع الملف مرة أخرى.",
  "attendance.errors.importCommitted": "تم استيراد هذا الملف من قبل.",
  "attendance.errors.importUnreadable": "تعذّرت قراءة الملف. صدّره بصيغة CSV أو .xlsx وحاول مرة أخرى.",
  "attendance.errors.requestNotFound": "هذا الطلب لم يعد موجودًا.",
  "attendance.errors.requestExists": "طلبت هذا بالفعل في ذلك اليوم.",
  "attendance.errors.requestClosed": "تم البت في هذا الطلب أو سحبه بالفعل.",
  "attendance.errors.permissionTooLong": "الإذن ده أطول من المسموح في اللائحة.",
  "attendance.errors.permissionOverQuota": "الإذن ده فوق حد الشهر، فالموارد البشرية بس اللي تقدر توافق عليه، مع كتابة السبب في التعليق.",
  "attendance.errors.breakAlreadyStarted": "أنت في استراحة بالفعل.",
  "attendance.errors.breakNotStarted": "أنت مش في استراحة.",
  "attendance.errors.breakInvalid": "راجع الأوقات: الاستراحة تنتهي بعد ما تبدأ، وجوه وقت الشغل في اليوم ده.",
  "attendance.errors.breakNotFound": "الاستراحة دي مبقتش موجودة.",
  "attendance.errors.weeklyRestRequired": "الأسبوع لازم يكون فيه يوم راحة واحد على الأقل (المادة 120).",
  "attendance.errors.validation": "لم تُقبل بعض البيانات. راجعها وحاول مرة أخرى."
}
